export enum TermsTypes {
  NUMBER_SALES_FACE_RECOG_CONTRACT = 'NUMBER_SALES_FACE_RECOG_CONTRACT',
  NUMBER_SALES_CONTRACT = 'NUMBER_SALES_CONTRACT',
}

export enum RedirectUrls {
  NUMBER_SALE_PAYMENT_REDIRECT = 'https://cabinet.bakcell.com/number-sale-result',
  ESIM_PAYMENT_REDIRECT = 'https://www.bakcell.com/esim-result',
}
